package com.happyukrainian.revision.kweb.pages.routes

import androidx.compose.runtime.Composable
import com.happyukrainian.revision.kweb.config.ButtonStyle
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import flashcards.FlashCard
import org.jetbrains.compose.web.css.percent
import practicetest.MaterialsResponse

@Composable
fun MaterialRoute(materials: MaterialsResponse?, onFlashCardsSelected: (List<FlashCard>) -> Unit) {
    if (materials == null) {
        SpanText("Loading...")
    } else {
        if (materials.flashCards.isNotEmpty()) {
            Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
                Button(
                    modifier = ButtonStyle.toModifier().width(80.percent),
                    onClick = {
                        onFlashCardsSelected(materials.flashCards)
                    }) {
                    SpanText("Flashcards")
                }
            }
        }
    }
}